import React from "react";
import {isEqual} from 'lodash';

import ReactTable from "react-table";
import {Button} from "reactstrap";
import {confirmAlert} from 'react-confirm-alert';
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";

const {StatelessModal} = Framework.Elements;

class Inventory extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Inventories_Items._name, API.RequestType.READ_ALL);
		super(props, model);

		Object.assign(this.state, {
			limit: 6,
			noteModalPkey: -1,
			noteModalBinaryId: -1,
			inventory_note: '',
			inventory_note_error: '',
		});


	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		const {data} = this.state;
		// TBD: Detach API and data formatting logic in base Collection class from UI?
		// Currently Inventory (extending View, parent of this component) needs child data from
		// this component to format the CSV data. This uses a callback, but since we're setting
		// state after state was set in the base Collection class, this causes an extra render
		// on every data change.
		if (!isEqual(data, prevState.data)) {
			this.props.formatCSVData(data);
		}

		if (this.state.scannedCode !== this.props.scannedCodeAlt) {
			this.setState({
				scannedCode: this.props.scannedCodeAlt
			}, this.shouldHandleScan);
		}

		this.syncRowColors();
	}




	shouldHandleScan = async () => {
		if (this.state.scannedCode && this.state.scannedCode.barcode) {
			let {data} = this.state;
			this.setState({loading: true});
			let invItems = null;
			let row = null;
			let product = null;
			try {
				let productModel = new API.BuildClass(Types.Products._name, API.RequestType.READ);

				//Verify what they scanned is actually a product that exists somewhere in the database
				productModel.object.pkey = this.state.scannedCode.barcode;
				productModel.object.id = this.state.scannedCode.barcode;
				productModel.parent = this.props.parent;
				product = await productModel.submit(null, API.RequestType.READ);
				let indexOfRow = 0;
				//Check if inventory product scanned exists in current view displayed to user. If it does, there is no reason to
				//query the database for the product since we already have all the information we need.
				row = data.find((row, i) => {
					if(row.product.toString() === product.pkey.toString()) {
						indexOfRow = i;
						return true;
					} else {
						return false;
					}
				})
			}
			catch (e) {
			}

			//product does not exist in current state so we must query the database for it.
			if (!row) {
				try {
					let iModel = new API.BuildClass(Types.Inventories_Items._name, API.RequestType.READ);
					iModel.parent = this.props.parent;
					iModel.object.id = product.pkey;
					iModel.object.pkey = product.pkey;
					iModel.object.binary_id = product.binary_id;
					iModel.request = 'GET_INVENTORY';
					invItems = await iModel.submit(null, 'GET_INVENTORY')
				} catch (e) {
				}

				//It is possible that the user already has multiple instances of the product in their inventory due to previous broken code so
				//we only want to grab one.
				if (invItems?.items?.length > 0) {
					row = invItems.items[0];
				}
			}
			try {
				Object.assign(this.model.object, {
					inventory: this.props.parent,
					inventory_binary_id: row ? row.inventory_binary_id : this.props.parent_binary_id,
					pkey: row ? row.pkey : null,
					product: product ? product.pkey : null,
					binary_id: row ? row.product_binary_id : product.binary_id,
					product_binary_id: row ? row.product_binary_id : product.binary_id,
					notes: row ? row.notes : '',
					scanned: row ? row.scanned + 1 : 1,
					removed: null,
				});

				let entry = await this.model.submit(null, row ? API.RequestType.UPDATE : API.RequestType.CREATE);

				if (row && entry) {
					data = data.filter(item => item.product.toString() !== product.pkey.toString())

					if(entry.scanned > 1) {
						entry.status_name = 'Duplicate Scan'
					}
					if (entry.scanned === 1) {
						entry.status_name = 'Scanned'
					}
					if (entry.scanned === 3) {
						entry.status_name = 'Has Inventory Note'
					}
					//Add last product scanned to top of user view
					data.unshift(entry);
				}
			} catch (e) {
			}
			this.setState({
				data,
				loading: false,
			});
			// this.onPageChange(0);
			// this.reloadTable();

		}

	}


	// override
	formatData = async (res) => {
		res.rows = this.formatRows(res.rows);

		return res;
	}

	formatRows = (rows) => {
		for (let i = 0, len = rows.length; i < len; i++) {
			let row = rows[i];
			switch (true) {
				case (row.removed === true): {
					row.status_name = 'Removed';
					break;
				}
				case (row.status === 2): {
					row.status_name = 'Not In Stock';
					break;
				}
				case (row.notes != null && row.notes.length > 0): {
					row.status_name = 'Has Inventory Note';
					break;
				}
				case (row.scanned === 0): {
					row.status_name = 'Not Scanned Yet';
					break;
				}
				case (row.scanned > 1): {
					row.status_name = 'Duplicate Scan';
					break;
				}
				case (row.scanned === 1): {
					row.status_name = 'Scanned';
					break;
				}
				default: {
					row.status_name = '';
					break;
				}
			}
		}

		return rows;
	}

	syncRowColors = () => {
		let {data} = this.state;
		for (let i = 0, len = data.length; i < len; i++) {
			let row = data[i];
			let el = document.querySelector(`.rt-table > .rt-tbody > div:nth-child(${i + 1})`);

			if (!el) continue;

			switch (true) {
				case (row.removed === true): {
					el.style.backgroundColor = '#b3b3b3';
					break;
				}
				case (row.status !== 1 || row.product_inventories?row.locations.pkey !== row.product_inventories?.location:false): {
					el.style.backgroundColor = '#f19e9e';
					break;
				}
				case (row.notes != null && row.notes.length > 0): {
					el.style.backgroundColor = '#d9edf7'
					break;
				}
				case (row.scanned === 0): {
					el.style.backgroundColor = 'inherit';
					break;
				}
				case (row.scanned > 1): {
					el.style.backgroundColor = '#fcf8e3';
					break;
				}
				case (row.scanned === 1): {
					el.style.backgroundColor = '#dff0d8';
					break;
				}
			}
		}
	}

	handleIncrement = async (e) => {
		let {data} = this.state;
		let pkey = parseInt(e.currentTarget.id);
		let binary_id = e.currentTarget.getAttribute('data-binary-id');
		let row = data.find((row) => row.pkey === pkey && row.binary_id === binary_id);

		if (!row) return;

		this.setState({loading: true});

		row.scanned++;

		Object.assign(this.model.object, {
			inventory: this.props.parent,
			inventory_binary_id: this.props.parent_binary_id,
			product: row.product,
			product_binary_id: row.product_binary_id,
			pkey,
			binary_id,
			notes: row.notes,
			scanned: row.scanned,
			removed: null,
		});


		try {
			await this.model.submit(null, API.RequestType.UPDATE);
		} catch (e) {
			this.setState({loading: false});
			return;
		}

		this.formatRows(data);

		this.setState({
			data,
			loading: false,
		});
	}

	handleDecrement = async (e) => {
		let {data} = this.state;
		let pkey = parseInt(e.currentTarget.id);
		let binary_id = e.currentTarget.getAttribute('data-binary-id');
		let row = data.find((row) => row.pkey === pkey && row.binary_id === binary_id);
		let {min} = this.model.properties.scanned.range;

		if (!row) return;

		this.setState({loading: true});

		row.scanned = Math.max(min, row.scanned - 1);

		Object.assign(this.model.object, {
			inventory: this.props.parent,
			inventory_binary_id: this.props.parent_binary_id,
			product_binary_id: row.product_binary_id,
			pkey,
			binary_id,
			notes: row.notes,
			scanned: row.scanned,
			removed: null,
		});

		try {
			await this.model.submit(null, API.RequestType.UPDATE);
		} catch (e) {
			this.setState({loading: false});
			return;
		}

		this.formatRows(data);

		this.setState({
			data,
			loading: false,
		});
	}

	handleNoteClick = (e) => {
		let {data} = this.state;
		let pkey = parseInt(e.currentTarget.id);
		let binary_id = e.currentTarget.getAttribute('data-binary-id');
		let row = data.find((row) => row.pkey === pkey && row.binary_id === binary_id);

		if (!row) return;

		this.setState({
			noteModalPkey: row.pkey,
			noteModalBinaryId: row.binary_id,
			noteModalValue: row.notes,
		})
	}

	handleNoteModalToggle = () => {
		this.setState({
			noteModalPkey: -1,
			noteModalBinaryId: -1,
			inventory_note: '',
			inventory_note_error: '',
		})
	}

	handleNoteModalChange = (name, value) => {
		this.setState({[name]: value});
	}

	handleNoteSubmit = async () => {
		let {data} = this.state;
		let {noteModalPkey, noteModalBinaryId, inventory_note} = this.state;
		let row = data.find((row) => row.pkey === noteModalPkey && row.binary_id === noteModalBinaryId);
		let {max} = this.model.properties.notes.range;

		if (!row) return;
		if (inventory_note.length > max) {
			this.setState({inventory_note_error: `Inventory notes cannot exceed ${max} characters.`});
			return;
		}

		this.setState({loading: true});

		row.notes = inventory_note;

		Object.assign(this.model.object, {
			inventory: this.props.parent,
			inventory_binary_id: this.props.parent_binary_id,
			product: row.product,
			product_binary_id: row.product_binary_id,
			pkey: noteModalPkey,
			binary_id: noteModalBinaryId,
			notes: inventory_note,
			scanned: row.scanned,
			removed: null,
		});

		try {
			await this.model.submit(null, API.RequestType.UPDATE);
		} catch (e) {
			this.setState({
				loading: false,
				inventory_note_error: 'There was an error updating this note.'
			});
			return;
		}

		this.formatRows(data);

		this.setState({
			data,
			noteModalPkey: -1,
			noteModalBinaryId: -1,
			inventory_note: '',
			inventory_note_error: '',
			loading: false
		});
	}

	handleRemoveItem = async (pkey, binary_id) => {
		let {data} = this.state;
		let rowIndex = data.findIndex((row) => row.pkey === pkey && row.binary_id === binary_id);

		if (rowIndex === -1) return;

		this.setState({loading: true});

		this.model.object.pkey = pkey;
		this.model.object.binary_id = binary_id;

		try {
			await this.model.submit(null, API.RequestType.DELETE);
		} catch (e) {
			this.setState({loading: false});
			return;
		}

		data[rowIndex].removed = !data[rowIndex].removed;
		if (data[rowIndex].scanned === 0 ) {
			data[rowIndex].status_name = 'Not Scanned Yet';
		}
		if (data[rowIndex].scanned === 1 ) {
			data[rowIndex].status_name = 'Scanned';
		}
		if (data[rowIndex].scanned > 1 ) {
			data[rowIndex].status_name = 'Duplicate Scan';
		}
		if (data[rowIndex].notes) {
			data[rowIndex].status_name = 'Has Inventory Note';
		}
		if (data[rowIndex].removed) {
			data[rowIndex].status_name = 'Removed';
		}

		this.setState({
			data,
			loading: false
		});

	}

	confirmDelete = (e) => {
		let pkey = parseInt(e.currentTarget.id);
		let binary_id = e.currentTarget.getAttribute('data-binary-id');

		confirmAlert({
			title: 'Confirm Delete',
			message: 'Are you sure you want to remove this inventory item?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => this.handleRemoveItem(pkey, binary_id),
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	};

	render() {
		const {data, pages, limit, loading, noteModalPkey, inventory_note, inventory_note_error} = this.state;
		const columns = [
			{
				Header: "Serial #",
				id: "products.serial_number",
				accessor: obj => obj.products.serial_number,
			},
			{
				Header: "Product",
				id: "products.type",
				width: 250,
				/** @param {Inventories_Items_Object} obj */
				accessor: obj => obj.products.type + ' | ' + (obj.products.manufacturer ? obj.products.manufacturers.name : obj.products.manufacturer_other) + ' | ' + obj.products.model,
			},
			{
				Header: "Stock",
				id: "product_statuses.name",
				/** @param {Inventories_Items_Object} obj */
				accessor: obj => obj.product_statuses.name,
			},
			{
				Header: "Status",
				id: "status",
				/** @param {Inventories_Items_Object} obj */
				accessor: 'status_name',
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: (props) => {
					return (
						<span>
							<Button
								id={props.original.pkey}
								data-binary-id={props.original.binary_id}
								color="green-meadow"
								size={"sm"}
								block={true}
								onClick={this.handleIncrement}>
								<i className={"fa fa-plus"}/>
							</Button>
						</span>
					);
				}
			},
			{
				Header: "Scanned",
				id: "scanned",
				/** @param {Inventories_Items_Object} obj */
				accessor: obj => obj.scanned,
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: (props) => {
					return (
						<span>
							<Button
								id={props.original.pkey}
								data-binary-id={props.original.binary_id}
								color="default"
								size={"sm"}
								block={true}
								onClick={this.handleDecrement}>
								<i className={"fa fa-minus"}/>
							</Button>
						</span>
					);
				}
			},
			{
				Header: "Inventory Notes",
				id: "notes",
				accessor: 'notes',
				Cell: (props) => {
					return (
						<div
							className="noteCell"
							id={props.original.pkey}
							data-binary-id={props.original.binary_id}
							onClick={this.handleNoteClick}>
							{props.original.notes}
						</div>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Button
								id={props.original.pkey}
								data-binary-id={props.original.binary_id}
								color="danger"
								size="sm"
								block={true}
								onClick={this.confirmDelete}>
								<i className="fa fa-times"/>
							</Button>
						</span>
					);
				}
			},
		];

		return (
			<Card className="InventoryCollection">
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Inventories', "")}
								{this.renderHeaderRight("Inventories", columns)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
				<StatelessModal
					size="md"
					title="Inventory Notes"
					name="inventoryNote"
					submitLabel="Update"
					isOpen={noteModalPkey > -1}
					onToggle={this.handleNoteModalToggle}
					onSubmit={this.handleNoteSubmit}>
					<div className="container">
						<Framework.Elements.TextField
							property={{name: 'inventory_note', value: ''}}
							value={inventory_note}
							error={inventory_note_error}
							update={this.handleNoteModalChange}
							multiline={4}
							label=""
						/>
					</div>
				</StatelessModal>
			</Card>
		)
	}
}

export default Inventory;
